import axios from 'axios';

const UserRootData = {
  user: {},
};

const SessionMixin = {
  computed: {
    user: {
      get() { return this.$root.$data.user; },
      set(user) { this.$root.$data.user = user; },
    },
  },
};

class Session {
  static resume() {
    const user = this.getUser();

    if (user) {
      axios.defaults.headers.common.Authorization = `Bearer ${user.UserWebToken}`;
      return Promise.resolve(user);
    }

    return Promise.reject(new Error('Invalid session. Please sign in again.'));
  }

  static begin(user, keepSignedIn) {
    const u = JSON.stringify(user);

    sessionStorage.setItem('user', u);

    if (keepSignedIn) {
      localStorage.setItem('user', u);
    }
  }

  static end() {
    localStorage.removeItem('user');
    sessionStorage.removeItem('user');
  }

  static getUser() {
    const user = localStorage.getItem('user') || sessionStorage.getItem('user');
    return JSON.parse(user);
  }
}

export {
  UserRootData,
  SessionMixin,
  Session,
};
